import "../common";
import "../components/FAQEntry";
import "../components/tracker/ImpressionInteractionTracker";
import "../components/FooterItemLinkNewsletter";

import { data } from "../../shared/state/payload";
import { add as addToHistory } from "../state/history";
import { trackPageVisit } from "@escapio/portal/tracker/Pinterest";

addToHistory({
	item_id: data.trackingId,
	name: data.articleTitle,
	label: data.articleTitle,
	link: location.pathname,
	type: data.page_search_type,
	type_label: data.page_search_type_label,
	is_alternative: false,
});
trackPageVisit(data.trackingId, data.articleTitle);
